import { Link } from "react-router-dom";
import logoEE from "@assets/events-awards/logo-ee.png";
import Ad from "@components/Advertisement/Ad";
import AdSettings from "@components/Advertisement/AdSettings";
import Container from "@components/Container/Container";
import GAData from "@components/GAData/GAData";
import Column from "@components/Grid/Column";
import Row from "@components/Grid/Row";
import Header from "@components/Header/Header";
import { useBreadCrumbState } from "@components/Header/helpers";
import MetaTags from "@components/MetaTags/MetaTags";
import {
  EVENTS_AWARDS_EE_LABEL,
  EVENTS_AWARDS_EE_PATH,
  EVENTS_AWARDS_SLOT,
} from "@pages/Section/layouts/EventsAwardsPage/utils/constants";
import { EventsAwardsLandingPageContextData } from "@pages/Section/layouts/EventsAwardsPage/utils/types";
import { sectionNavigationItems } from "@util/constant";
import { useDetectAdBlock } from "adblock-detect-react";

export default function EventsAwardsEEPageContent({
  title,
  // article,
}: EventsAwardsLandingPageContextData): React.ReactElement {
  const { isShowBreadCrumb } = useBreadCrumbState();
  const adBlockDetected = useDetectAdBlock();

  return (
    <div
      className="w-full"
      data-testid="events-awards-ee-page-content-component"
    >
      <AdSettings
        adNames={["lb1", "prestitial", "catfish", "abm"]}
        path={EVENTS_AWARDS_EE_PATH}
        adTargets={[{ key: "page", value: "listing" }]}
      />

      <GAData
        title="Emerging_Enterprise_Index"
        level2="events awards"
        adblocker={adBlockDetected ? 1 : 0}
      />

      <MetaTags
        title={title}
        description={`THE BUSINESS TIMES ${EVENTS_AWARDS_EE_LABEL} - Find ${EVENTS_AWARDS_EE_LABEL} News & Headlines, insight and analysis in Singapore, Asia-Pacific & global markets news at The Business Times.`}
        ogType="website"
        slug={EVENTS_AWARDS_EE_PATH}
      />

      <Ad
        adType="lb1"
        className="flex min-h-[50px] flex-col items-center justify-center border-b border-gray-175 bg-gray-125 py-1 text-center md:py-3 lg:min-h-[250px]"
      />

      <Header
        displayBreadcrumb={isShowBreadCrumb}
        parentCategory={EVENTS_AWARDS_SLOT}
        categoryDataMapping={sectionNavigationItems}
        enableTopStoriesLink={false}
      />

      <Container>
        <Row rootClassName="justify-center">
          <Column rootClassName="w-full lg:w-8/12 text-center my-8">
            <Link to={EVENTS_AWARDS_EE_PATH}>
              <img
                src={logoEE}
                alt="Emerging Enterprise logo"
                width={190}
                height={85}
                className="mx-auto"
              />
            </Link>
          </Column>
        </Row>
      </Container>

      <Ad adType="catfish" />

      <Ad adType="abm" />

      <Ad adType="prestitial" />
    </div>
  );
}
